import React from "react"
import Typography from '@mui/material/Typography';


export const TextGutHeart = () => {

return(
<div>
In the last decade, the relationship between the microbiota and cardiovascular disease has become a major topic of interest.<br /><br />
Several metabolic pathways may mediate the pathogenic effects of an altered microbiota, including the trimethylamine (TMA)/trimethylamine
N-oxide (TMAO) and the bile acids pathways. TMAOs have been associated with increased risk for CVD.<br /><br />

The source of many of the microorganisms that have been associated with atherosclerotic plaques, endothelial dysfunction,
and resulting CVDs is their translocation from the gut into the systemic circulation. Metabolites produced by the microbiota may
also promote kidney injury as they are concentrated and excreted in the kidney.<br /><br />

Conditions that increase microbial translocation from the gut, such as overproduction of TMAOs and urea have been linked to 
systemic inflammation, heart failure, and hypertension. <br /><br />


Evidence suggest that diet potentially modulates the gut microbiota
by regulating the balance between pathogenic and beneficial
microbes or microbial products. Vegetarian diets foster a
beneficial microbiota composition by increasing Prevotella enterotype
whereas diets high in animal protein foster Bacteroides
enterotype and other species associated with proatherogenic
metabolites and CVD. <br /><br />

The production of the proatherogenic
metabolite TMAO, resulting from TMA oxidation by the liver enzyme
flavin monooxygenase 3 and its release into the systemic circulation
have been linked to coronary plaques, peripheral artery disease, the
severity of CVD, and its complications including stroke, myocardial
infarction, and death. Common dietary nutrients possessing
a TMA moiety, such as the choline, phosphatidylcholine, and Lcarnitine
present in red meat, fish, and eggs after microbial
metabolism, are the main contributors of TMAO-mediated effects
that promote artherosclerosis. <br /><br />

The underlying mechanisms by which TMAO contributes to CVD remain unknown. However,
preliminary evidence suggests that TMAO stimulates inflammatory pathways with activation of cells of the innate immunity response
that propagate atherosclerosis. Also TMAO interferes with platelet function through stimulus-dependent calcium signaling, promoting
atherothrombotic events.<br /><br />

<br /><br />

<Typography component="span" variant="h5" sx={{fontWeight: '700'}}>TMAO biosynthesis and metabolism: </Typography>
<br /><br />

Choline, phosphatidylcholine, and L-carnitine found in fish, red meat and eggs are metabolized
into TMA by colonic microbiota. The TMA that enters the systemic circulation is oxidized into TMAO by FMO3 in the liver, which is released back
into the circulation, leading to platelet and inflammatory pathway activation. Inflammatory injury in the endothelium, along with increased
foam cell formation and platelet activation, contributes to the progression of atherosclerosis and development of atherothrombotic events.

</div>
)
}